import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { BehaviorSubject, distinctUntilChanged, filter, interval, Observable, Subscription, takeWhile } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class IdleService {
showWarningModal$ = new BehaviorSubject<boolean>(false);
  private isStarted = false;
  private countdownSubject = new BehaviorSubject<number>(0);
  countdown$: Observable<number> = this.countdownSubject.asObservable();
  private countdownTimerSub: Subscription;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private router: Router,
    private authService: AuthService
  ) {}

  startWatching() {
    if (this.isStarted) return;
    this.isStarted = true;

    this.idle.setIdle(28 * 60); 
    this.idle.setTimeout(2 * 60);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.subscribe(() => {
      this.showWarningModal$.next(true);
    });

    this.idle.onTimeout.subscribe(() => {
      this.showWarningModal$.next(false);
      this.authService.logout(true);
      this.countdownSubject.next(0);
      if (this.countdownTimerSub) this.countdownTimerSub.unsubscribe();
      this.stopWatching();
    });

    this.idle.onTimeoutWarning.subscribe((countdown: number) => {
      this.showWarningModal$.next(true);
      this.startCountdown(countdown);
    });

    this.idle.onInterrupt.subscribe(() => {
      if(!this.isWarningVisible) {
        this.resetTimers();
      }
    });

    
    this.idle.onIdleEnd.subscribe(() => {
      if(!this.isWarningVisible) {
        this.showWarningModal$.next(false);
        this.countdownSubject.next(0);
        if (this.countdownTimerSub) this.countdownTimerSub.unsubscribe();
      }
    });

    this.countdown$.pipe(
      distinctUntilChanged(),
      filter(value => value === 0)
    ).subscribe(() => {
      if (this.isWarningVisible) {
        this.authService.logout(true); 
        this.stopWatching();
        this.showWarningModal$.next(false);
      }
    });

    this.keepalive.interval(15);
    this.idle.watch();
  }

  stopWatching() {
    this.isStarted = false;
    this.idle.stop();
    this.showWarningModal$.next(false);
  }

  stayLoggedIn() {
    this.showWarningModal$.next(false);
    this.idle.watch(); 
  }

  private resetTimers() {
    this.idle.watch();
  }

  get isWarningVisible(): boolean {
    return this.showWarningModal$.getValue();
  }

  private startCountdown(seconds: number): void {
  if (this.countdownTimerSub) {
    this.countdownTimerSub.unsubscribe();
  }

  this.countdownSubject.next(seconds);

  this.countdownTimerSub = interval(1000).pipe(
    takeWhile(() => this.countdownSubject.getValue() > 0)
  ).subscribe(() => {
    const newValue = this.countdownSubject.getValue() - 1;
    this.countdownSubject.next(newValue);
  });
}
}
